// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KwUp","col":"styles_col__2WsHH"};